import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { BASE_SP_V2_PROGRESS_BY_CONTENT_PATH } from "../constants"
import { getServiceErrorMessage } from "../../helpers"
import { Context, Transitions } from "../../types"
import { EocStudyPlanResponse } from "../../../../../../types/gqlTypes/graphql"
import { getStudentStudyPlanProgressModel } from "../helpers"

export const getProgressByContentTableDataTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getProgressDataByCurrentPlan",
    src: "getProgressDataByCurrentPlan",
    onDone: [
      {
        target: `${BASE_SP_V2_PROGRESS_BY_CONTENT_PATH}.get_progress_by_content_progress`,
        actions: assign<Context, DoneInvokeEvent<EocStudyPlanResponse>>(
          (_ctx, evt) => {
            return {
              progressByContentPlan: evt.data.plan
            }
          }
        ),
        cond: ctx => !ctx.reportingFiltersState?.student?.[0]
      },
      {
        target: `${BASE_SP_V2_PROGRESS_BY_CONTENT_PATH}.idle`,
        actions: assign<Context, DoneInvokeEvent<EocStudyPlanResponse>>(
          (ctx, evt) => {
            return {
              progressByContentPlan: evt.data.plan,
              progressBySubjectsModel: {
                [ctx.subject]: getStudentStudyPlanProgressModel(evt.data.plan)
              }
            }
          }
        )
      }
    ],
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getProgressDataByCurrentPlan", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
